import styled from 'styled-components';
import { MediaStyle, GridRowStyle, GridColStyle } from '../../utils/style-utils';

export const ListRowStyle = GridRowStyle.extend`
  flex-direction: column;
  display: block;
  ${ MediaStyle.md`
    display: flex;
    flex-direction: row;
    flew-wrap: nowrap;
    margin-top: 15px;
  ` }
`;

export const ListColStyle = GridColStyle.extend`
  ${props => props.quarter && `
    & > div {
      margin-bottom: 15px;
    }
  `}
  ${ MediaStyle.md`
    width: ${props => props.quarter ? 'calc(25% - 10px)' : 'auto'};
    margin: ${props => props.quarter ? '75px 15px 10px 5px' : '10px 5px 10px 15px'};
    flex: ${props => props.quarter && 'none'};
    flex-grow: ${props => !props.quarter && '1'};
    flex-shrink: ${props => !props.quarter && '1'};
    flex-basis:${props => !props.quarter && '0'}; 
  ` }
`;

export const FilterWrapperStyle = styled.div`
  & > div {
    margin-bottom: 15px;
  }
`;

export const DropdownContainerStyle = styled.div`
  margin-bottom: 40px;
  ${ MediaStyle.md`
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-end;
    z-index: 1;
  `}
`;

export const CardContainer = styled.div`
  margin-bottom: 20px;
`;

export const SearchResultTextStyle = styled.div`
  margin-top: 15px;
  margin-bottom: 5px;
  display: inline-block;
  ${ MediaStyle.md`
    margin-top: 20px;
    margin-bottom: 0;
    display: block;
  `}
`;


// WEBPACK FOOTER //
// ./src/components/searchResults/style.js